<button (click)="onClick.emit()" [disabled]="disabled || _disabled" mat-raised-button color="warn">{{ label }}
  <mat-icon *ngIf="loading">
    <mat-spinner color="accent" diameter="20">
    </mat-spinner>
  </mat-icon>
</button>
